import { render } from "./PointageDestData.vue?vue&type=template&id=5d666128&scoped=true"
import script from "./PointageDestData.vue?vue&type=script&lang=js"
export * from "./PointageDestData.vue?vue&type=script&lang=js"

import "./PointageDestData.vue?vue&type=style&index=0&id=5d666128&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d666128"]])

export default __exports__